import Nav from "../Components/Nav/Nav";
import Footer from "../Components/Footer/Footer";
import Projects from "../Components/Projects/Projects";

function ProjectGallery() {
  return (
    <div className="home">
      <Nav></Nav>
      <Projects></Projects>
      <Footer></Footer>
    </div>
  );
}

export default ProjectGallery;
